import request from './request.js'

// 获取字典表新
export const getDicListNew = params => {
  return request({
    url: `/hospro/dicts/list`,
    method: 'GET',
    params
  })
}

// 我的咨询列表接口
export const getVisitRecordOnlineListByDoctor = data => {
  return request({
    url: `/hospro/hospital/selInfo?func=fGetVisitRecordOnlineListByDoctor`,
    method: 'POST',
    data
  })
}

// 获取就诊记录详情
export const getVisitRecordOnlineDetail = data => {
  return request({
    url: `/hospro/hospital/selInfo?func=fGetVisitRecordOnlineDetail`,
    method: 'POST',
    data
  })
}

/* 
  问诊退号接口
*/
export const retreatOperate = data => {
  return request({
    url: `/hospro/hospital/businessMethods/retreatOperate`,
    method: 'POST',
    data
  })
}

// 查询本月已使用统筹金额接口
export const fundPayUsed = params => {
  return request({
    url: `/hospro/hospital/selInfo?func=getPhisProxyService`,
    method: 'POST',
    data: {
      params
    }
  })
}

// 医生接诊
export const acceptedPatientVisit = data => {
  return request({
    url: `/hospro/hospital/selInfo?func=fAcceptedPatientVisit`,
    method: 'POST',
    data
  })
}

// 获取我的关注列表
export const getPatientAttentionTo = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetPatientAttentionTo',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 查询医生配置
export const aGetDoctorServiceConfig = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetDoctorServiceConfig',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 医生接停诊
export const aDoctorOpenService = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fDoctorOpenService',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 医生配置
export const aGetDoctorConfig = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetDoctorConfig',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 获取医院列表
export const getHospitalList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetHospitalList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 获取医院信息
export const getHospitalInfo = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetHospitalInfo',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 获取字典表
export const getDicList = data => {
  return request({
    url: `/hospro/dicts/list`,
    method: 'GET',
    params: {
      func: 'fGetDicList',
      ...data
      // hospitalID: data.hospitalID || '',
    }
  })
}

// 小程序登录
export const loginOfWXlite = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fLoginOfWXlite',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 获取业务字典表
export const getBusinessDicList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetBusinessDicList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

export const getBusinessDicListByName = tableName => {
  const hospitalID = localStorage.getItem('hospitalID')
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetBusinessDicList',
      hospitalID,
      params: JSON.stringify({
        pageNum: 1,
        pageSize: 1,
        tableName,
        code: hospitalID
      })
    }
  })
}

// 获取医生列表
export const getDoctorList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetDoctorList',
      params: JSON.stringify(data)
    }
  })
}

// 获取药师列表
export const aGetPharmacistPage = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetPharmacistPage',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 获取我的受者
export const getMyPatient = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetMyPatient',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 获取资源
export const aGetResource = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetResource',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 获取内容
export const aGetContent = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetContent',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 获取服务方式
export const aGetService = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetService',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 获取公告
export const getNotices = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'getNotices',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 获取待审核列表
export const getPrescripCheckList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetPrescripCheckList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 获取受者标签 (废弃？)
export const getLabelPatient = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetLabelPatient',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 发送消息
export const doctorSendMessage = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fDoctorSendMessage',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 我发送的消息
export const getMySendMessageList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetMySendMessageList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 查询身份证号
export const getCardNo = param => {
  return request({
    url: `/hospro/desensitization/display/idcard`,
    method: 'GET',
    param
  })
}

// 查询订单结算明细
export const getBalanceDetail = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetServiceOrder',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 查询提现明细
export const getBalanceList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetBalanceList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 查询我的余额
export const aGetBalance = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'getBalance',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 发送短信代理
export const sendMessage = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'sendMessage',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 提现操作
export const withdraw = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fWithdraw',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 获取代理电话号
export const getAgentPhoneNumber = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetAgentPhoneNumber',
      hospitalID12: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 解绑代理电话
export const aUnbindAgentPhoneNumber = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fUnbindAgentPhoneNumber',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 语音通知
export const sendVoiceNotify = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fSendVoiceNotify',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 医生结诊
export const finishedPatientVisit = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fFinishedPatientVisit',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 查询群组
export const getGroupID = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetGroupID',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 查询诊疗项目
export const getTreatmentItemsList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetTreatmentItemsList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 获取药品列表
export const getDrugListByCache = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetDrugListByCache',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 查询就诊人信息
export const getRelatedPatientList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetRelatedPatientList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 撤销非药品处方
export const cancelTreatment = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fCancelTreatment',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 处方审核
export const updatePrescripCheck = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fUpdatePrescripCheck',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 更新处方数据类型
export const updatePrescripDataType = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fUpdatePrescripDataType',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 查询e签宝签名状态
export const querySignStatus = data => {
  return request({
    url: `/hospro/hospital/businessMethods/querySignStatus`,
    method: 'POST',
    data
  })
}

// 开检查检验
export const createTreatment = data => {
  return request({
    url: `/hospro/hospital/businessMethods/fCreateTreatment`,
    method: 'POST',
    data
  })
}

// 校验库存
export const aCheckDrugStock = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fCheckDrugStock',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 开处方
export const createPrescrip = data => {
  return request({
    url: `/hospro/hospital/businessMethods/fCreatePrescrip`,
    method: 'POST',
    data
  })
}

// 查询区划地址信息
export const getAddressByAreacode = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetAddressByAreacode',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 更新物流信息
export const updateLogisticsInfo = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'updateLogisticsInfo',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 处方快递下单
export const aCreateOrder = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'createOrder',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 查询快递公司列表
export const getExpressCompanyList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetExpressCompanyList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 发药
export const drugDispend = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fDrugDispend',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 查询处方模板
export const getPrescripTemplate = data => {
  return request({
    url: `/hospro/hospital/businessMethods/fGetPrescripTemplate`,
    method: 'POST',
    data
  })
}

/**
 * 创建处方模板
 *
 * @param {*} data
 * @return {*}
 */
// 发药
export const addPrescripTemplate = data => {
  return request({
    url: `/hospro/hospital/businessMethods/fAddPrescripTemplate`,
    method: 'POST',
    data
  })
}

// 发药
export const getAllLabelList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetAllLabelList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 获取药品列表
export const getDrugList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetDrugList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 互联网就医记录列表
export const getVisitRecordOnlineList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetVisitRecordOnlineList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 互联网病历列表
export const getVisitRecordOnlineListNew = data => {
  return request({
    url: `/hospro/hospital/businessMethods/getVisitRecordOnlineList`,
    method: 'POST',
    data
  })
}

// 首诊记录列表
export const getVisitRecordList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetVisitRecordList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 查询诊断信息
export const aGetSymptomListByCache = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetSymptomListByCache',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 获取科室列表
export const getDepartmentList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetDepartmentList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 提交病历
export const updateMedicalRecord = data => {
  return request({
    url: `/hospro/hospital/businessMethods/fUpdateMedicalRecord`,
    method: 'POST',
    data
  })
}

// 消息统一推送
export const pushAllMessages = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fPushAllMessages',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 查询说明书数据接口
export const selectDrugManual = data => {
  return request({
    url: `/hospro/hospital/businessMethods/selectDrugManual`,
    method: 'POST',
    data
  })
}

// 查询护士列表接口
export const getNurseList = params => {
  return request({
    url: `/nurses`,
    method: 'GET',
    params
  })
}

// 开始服务接口
export const startService = params => {
  return request({
    url: `/NurseOrders/startService?orderNo=${params}`,
    method: 'PUT',
    data: {}
  })
}

// 出发服务接口
export const startsetout = params => {
  return request({
    url: `/NurseOrders/depart?${params}`,
    method: 'PUT',
    data: {}
  })
}

//取消订单
export const cancelOrder = params => {
  return request({
    url: `/NurseOrders/cancel?${params}`,
    method: 'PUT',
    data: {}
  })
}

// 完成服务接口
export const completeService = params => {
  return request({
    url: `/NurseOrders/completeService?orderNo=${params}`,
    method: 'PUT',
    data: {}
  })
}

// 查询护理订单详情接口
export const getNurseOrderDetail = params => {
  return request({
    url: `/NurseOrders/detail`,
    method: 'GET',
    params
  })
}

// 手机号解密接口
export const seePhone = params => {
  return request({
    url: `/hospro/desensitization/display/phone`,
    method: 'GET',
    params
  })
}

// 群发记录列表查询
// POST /hospro/bulk/selectBulkRecordPage
// 接口ID：34651094
// 接口地址：https://www.apifox.cn/web/project/956367/apis/api-34651094
export const selectBulkRecordPage = data => {
  return request({
    url: `/bulk/selectBulkRecordPage`,
    method: 'POST',
    data
  })
}

// 群发记录查看详情
// POST /hospro/bulk/selectBulkRecordDetails
// 接口ID：34677192
// 接口地址：https://www.apifox.cn/web/project/956367/apis/api-34677192
export const selectBulkRecordDetails = data => {
  return request({
    url: `/bulk/selectBulkRecordDetails`,
    method: 'POST',
    data
  })
}

// 发送群发消息
// PUT /hospro/bulk/saveBulkRecordSend
export const saveBulkRecordSend = data => {
  return request({
    url: `/bulk/saveBulkRecordSend`,
    method: 'PUT',
    data
  })
}

/**
 * 获取消息中心列表
 * @param { object } data 上送参数
 * @return { promise }
 * **/

export const getMessageList = data => {
  return request({
    url: `/hospro/bulk/selectMessageRecordsPage`,
    method: 'POST',
    data
  })
}

/**
 * 批量更新未读消息状态
 * @param { object } data 上送参数
 * @return { undefined }
 * **/

export const updateMessageRecordsReadStatus = data => {
  return request({
    url: `/hospro/bulk/updateMessageRecordsReadStatus`,
    method: 'PUT',
    data
  })
}

/* 
  提交草稿处方 
  action是固定值
*/
export const draftSaving = data => {
  return request({
    url: `/hospital-server/prescriptions?action=createPrescriptionDraft`,
    method: 'POST',
    data
  })
}

// 修改草稿处方
export const updateDraftSaving = data => {
  return request({
    url: `/hospital-server/prescriptions?action=updatePrescription`,
    method: 'PUT',
    data
  })
}

/* 
  批量提交草稿处方 
  action是固定值
*/
export const batchDraftSaving = data => {
  return request({
    url: `/hospital-server/prescriptions?action=batchCreatePrescriptionOfUncreated`,
    method: 'PUT',
    data
  })
}

/* 
  查询诊断证明
*/
export const doctorGetMedicalCertificate = data => {
  return request({
    url: `/medicalCertificate/fDoctorGetMedicalCertificate`,
    method: 'POST',
    data
  })
}

/* 
  同步给受者
*/
export const synchronizeMedicalCertificate = data => {
  return request({
    url: `/medicalCertificate/fSynchronizeMedicalCertificate`,
    method: 'POST',
    data
  })
}

/* 
  查询检查报告列表
*/
export const getExamMasterList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'getExamMasterList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

/* 
  查询检验报告列表
*/
export const getMedicalLabMasterList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'getMedicalLabMasterList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

/* 
  查询检验报告详情
*/
export const getMedicalLabDetailList = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'getMedicalLabDetailList',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

/* 
  查询历史处方列表
*/
export const getHisPrescripList = params => {
  return request({
    url: `/hospital-server/prescriptions`,
    method: 'GET',
    params
  })
}

/* 
  查询病历模板列表
*/
export const getRecordTemplateList = data => {
  return request({
    url: `/hospro/medicalRecordTemplate/getList`,
    method: 'POST',
    data
  })
}
/**
 * @description 获取诊疗（非药品处方）详情
 * @param {*} data
 * @returns
 */
export const fGetTreatmentDetail = data => {
  return request({
    url: `/hospro/hospital/businessMethods/fGetTreatmentDetail`,
    method: 'POST',
    data
  })
}

/**
 * @description 获取药品处方详情
 * @param {*} data
 * @returns
 */
export const fGetPrescripDetails = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetPrescripDetails',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

/**
 * @description 查询就诊记录详情
 * @param {*} data
 */
export const getVisitRecordOnlineDetails = data => {
  return request({
    url: `/hospro/hospital/businessMethods/getVisitRecordOnlineDetails`,
    method: 'POST',
    data
  })
}

/**
 * @description 查询药品用法列表
 * @param {*} data
 */
export const fetchDrugUsageList = params => {
  return request({
    url: `/hospro/drug/drugUsage`,
    method: 'GET',
    params
  })
}

/**
 * @description 查询药品频次列表
 * @param {*} data
 */
export const fetchDrugFrequenceList = params => {
  return request({
    url: `/hospro/drug/drugFrequence`,
    method: 'GET',
    params
  })
}

/**
 * @description 查询受者健康档案
 */
export const getPatientHealthDocument = data => {
  return request({
    url: `/hospro/chronicDisease/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetPatientHealthDocument',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

/**
 * @description 心身医学签到
 */
export const postPsychosomaticSign = data => {
  return request({
    url: `/hospro/PsychosomaticMedicine/SignIn/signIn`,
    method: 'POST',
    data
  })
}

// 检查报告列表查询
//   GET /hospro/examreport/list
//   接口ID：132312100
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-132312100
export const getExamReportList = params => {
  return request({
    url: `/examreport/list`,
    method: 'GET',
    params
  })
}

// 查看检查影像
//   GET /hospro/examreport/viewReport
//   接口ID：132669756
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-132669756
export const seeViewReport = params => {
  return request({
    url: `/examreport/viewReport`,
    method: 'GET',
    params
  })
}

// 查询手术项目信息
//   GET /hospro/SurgeryItems
//   接口ID：143660668
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-143660668
export const getSurgeryItemsList = params => {
  return request({
    url: `/SurgeryItems`,
    method: 'GET',
    params
  })
}

// 日间手术预约查询
//   GET /hospro/SurgicalApplicationForms
//   接口ID：143710748
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-143710748
export const getSurgicalApplicationFormsList = params => {
  return request({
    url: `/hospro/SurgicalApplicationForms`,
    method: 'GET',
    params
  })
}

// 日间手术预约详情
//   GET /hospro/SurgicalApplicationForms/{id}
//   接口ID：143721094
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-143721094
export const getSurgicalApplicationFormsDetail = id => {
  return request({
    url: `/hospro/SurgicalApplicationForms/${id}`,
    method: 'GET',
    params: {}
  })
}

// 日间手术单撤销
//   PUT /hospro/SurgicalApplicationForms/{id}
//   接口ID：143724629
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-14372462
export const revokeSurgicalApplicationForms = id => {
  return request({
    url: `/hospro/SurgicalApplicationForms/${id}?action=cancel`,
    method: 'PUT',
    data: {}
  })
}

// 日间手术预约提交
//   POST /hospro/SurgicalApplicationForms
//   接口ID：143707136
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-143707136
export const submitSurgicalApplicationForms = data => {
  return request({
    url: `/hospro/SurgicalApplicationForms`,
    method: 'POST',
    data
  })
}

// 医生审核处方退款申请
//   PUT /hospro/Prescription/{prescriptionId}/refund
//   接口ID：145351331
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-145351331
export const refusalReviewPrescription = data => {
  return request({
    url: `/prescription/${data.id}/refund`,
    method: 'PUT',
    data: {}
  })
}

// 医生审核检查检验退款申请
//   PUT /hospro/treatmentDetail/refund
//   接口ID：145353530
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-145353530
export const refusalReviewTreatment = data => {
  return request({
    url: `/treatmentDetail/refund`,
    method: 'PUT',
    data
  })
}

// 密码登录
export const passwordLogin = (data, header) => {
  return request({
    headers: {
      noSign: true,
      ...header
    },
    url: `/hospro/login`,
    method: 'POST',
    data
  })
  // return requestUrl('/hospro/login', data, 'POST', {
  // noSign: true,
  // header
  // })
}

// 验证码登录
export const vcodeLogin = (data, header) => {
  return request({
    headers: {
      noSign: true,
      ...header
    },
    url: `/hospro/phoneLogin`,
    method: 'POST',
    data
  })
}

// 获取验证码
export const getVerifyCode = (data, header) => {
  return request({
    headers: {
      ...header
    },
    url: `/hospro/getVerifyCode`,
    method: 'POST',
    data
  })
}

// 获取用户角色信息
export const getBasicUserInfoOfHospital = header => {
  return request({
    url: '/hospro/user?action=basicUserInfoOfHospital',
    method: 'GET',
    heandes: header
  })
}

//修改协同门诊接诊状态
export const updateCollaborativeReceptionStatus = data => {
  return request({
    url: `/hospro/Doctors/updateCollaborativeReceptionStatus?`,
    method: 'PUT',
    data
  })
}

export const updateUpdPwd = data => {
  return request({
    url: '/hospro/updPwd',
    method: 'POST',
    data,
    headers: {
      contentType: 'application/json'
    }
  })
}

export const onLoginCheck = data => {
  return request({
    url: '/hospro/loginCheck',
    data,
    method: 'POST',
    headers: {
      contentType: 'application/json'
    }
  })
}

export const onLostPwd = data => {
  return request({
    url: '/hospro/lostPwd',
    data,
    method: 'POST',
    headers: {
      contentType: 'application/json'
    }
  })
}

// 协同门诊取消挂号
// https://apidoc.docbook.com.cn/web/#/33/1404
export const fCancelReg = params => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fCancelReg',
      hospitalID: params.hospitalID || '',
      params: JSON.stringify(params)
    }
  })
}

// 获取医院列表
// export const getHospitalList = data => {
//   return requestBasic({
//     url: '/hospro/hospital/list',
//     data,
//     options: {
//       header: {
//         contentType: 'application/json'
//       }
//     }
//   })
// }

// https://apidoc.docbook.com.cn/web/#/33/2126
// 180101获取排班信息（支持搜索）
export const arrangeByDay = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'getArrangeByDay',
      hospitalID: data.hospitalID || '',
      params: JSON.stringify(data)
    }
  })
}

// 基层机构查询上级医院信息
// GET /hospro/CollaborativeOutpatient/hospitals
// 接口ID：30551546
// 接口地址：https://www.apifox.cn/web/project/956367/apis/api-30551546
export const getSuperiorHospitals = params => {
  return request({
    url: '/hospro/CollaborativeOutpatient/hospitals',
    method: 'GET',
    params
  })
}

/**
 * 010101专家排班查询（2）
 * https://apidoc.docbook.com.cn/web/#/33/1356
 */
export const fGetSchemaDoctorList = data => {
  return request({
    url: '/hospro/hospital/selInfo?func=fGetSchemaDoctorList',
    method: 'post',
    data
  })
}

/**
 * 010701医生列表查询
 * https://apidoc.docbook.com.cn/web/#/33/1382
 *
 * @param {*} params
 * @return {*}
 */
export const fGetDoctorList = params => {
  return request({
    url: '/hospro/hospital/selInfo?func=fGetDoctorList',
    method: 'post',
    data: params
  })
}

// 协同门诊互联网挂号
// POST /hospro/hospital/selInfo
// 接口ID：31256310
// 接口地址：https://www.apifox.cn/web/project/956367/apis/api-31256310
export const fAddReginfo = params => {
  return request({
    url: '/hospro/hospital/selInfo?func=fAddReginfo',
    method: 'post',
    data: params
  })
}

/**
 * 获取受者列表
 *
 * @param {*} params
 * @return {*}
 */
export const fGetPatientList = params => {
  const param = {
    url: '/hospro/hospital/selInfo?func=fGetPatientList',
    method: 'POST',
    data: {
      Authorization: 'eWRrY19jb2xsZWdlOlluUDhISE1zUFE1czhjRHA',
      ...params
    },
    headers: {
      hospitalID: params.hospitalID
    }
  }
  return request(param)
  // const  = request(param)
  // fGetPatientList.cancelToken = param.source
  // return request
}

/**
 * 查询民族、国家
 * 接口id: 75902357
 * 接口地址：https://www.apifox.cn/link/project/956367/apis/api-75902357
 * **/
export const getNotCommonlyUsedDictionary = code => {
  return request({
    url: `/hospro/dicts/lazy?tableName=${code}`,
    method: 'GET',
    data: {}
  })
}

// 查看身份证号
export const seeCardNo = params => {
  return request({
    headers: {
      'Content-type': 'application/json'
    },
    url: '/hospro/desensitization/display/idcard',
    method: 'GET',
    params
  })
}

export const getVisitRecordOnlineList2 = data => {
  return request({
    url: '/hospro/hospital/selInfo?func=fGetVisitRecordOnlineList',
    method: 'POST',
    data
  })
}

// 保存协同门诊报告
// POST /hospro/hospital/selInfo/businessMethods/fUpdateReginfo
// 接口ID：30624355
// 接口地址：https://www.apifox.cn/web/project/956367/apis/api-30624355
export const fUpdateReginfo = data => {
  return request({
    url: '/hospro/hospital/businessMethods/fUpdateReginfo',
    method: 'POST',
    data
  })
}

export /**
 * 查询预约挂号信息
 *
 * @param {*} visitID
 * @return {*}
 */
const fQueryReginfo = visitID => {
  return request({
    url: '/hospro/hospital/selInfo?func=fQueryReginfo',
    method: 'POST',
    data: {
      visitID,
      schemaType: '4'
    }
  })
}

// 协同门诊发起视频时短信通知受者
//   PUT /hospro/VisitRecordOnline/{visitID}/callNotice
//   接口ID：194358614
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-194358614
export const callNotice = data => {
  return request({
    url: `/hospro/VisitRecordOnline/${data.visitID}/callNotice`,
    method: 'PUT',
    data
  })
}

/**
 * @description 获取转诊列表
 * @param {Object} params
 * @returns {Promise}
 */
export const getReferralList = params => {
  return request({
    url: '/hospro/referral/getReferralList',
    method: 'GET',
    params
  })
}

/**
 * @description 申请转诊
 * @param {Object} data
 * @returns {Promise}
 */
export const applyForReferral = data => {
  return request({
    url: '/hospro/referral',
    method: 'POST',
    data
  })
}

// 证件信息校验
//   POST /hospro/hospital/checkCard
//   接口ID：207237407
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-207237407
export const getCheckCard = data => {
  return request({
    url: `/hospro/hospital/checkCard`,
    method: 'POST',
    data
  })
}

/**
 * @description 获取转诊详情
 * @param {string} id
 * @returns {Promise}
 *
 */
export const getReferralDetail = id => {
  return request({
    url: `/hospro/referral/getReferralDetail/${id}`,
    method: 'GET'
  })
}

/**
 * @description 转诊审核
 * @param {Object} data
 * @returns {Promise}
 */
export const auditReferral = ({ action, id, checkState }) => {
  return request({
    url: `/hospro/referral?action=${action}&checkState=${checkState}&id=${id}`,
    method: 'PUT',
    data: {
      // 没有这个接口签名报错
      action,
      id,
      checkState
    }
  })
}

// 入驻详情-受者端
//   POST doctorJoinApply/applyDetails
//   接口ID：218872043
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-218872043
export const getApplyDetails = data => {
  return request({
    url: `/doctorJoinApply/applyDetails?telNo=${data.telNo}`,
    method: 'POST',
    data
  })
}

// 科联体加入申请查询
//   GET /departmental-consortium/departments/union/join/application
//   接口ID：243968487
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-243968487
export const getApplyDetailsH5 = params => {
  return request({
    url: `/departmental-consortium/departments/union/join/application`,
    method: 'GET',
    params
  })
}

// 确认签约
//   PUT doctorJoinApply/confirmSigning
//   接口ID：219178910
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-219178910
export const confirmSigning = data => {
  return request({
    url: `/doctorJoinApply/confirmSigning?id=${data.id}&hospitalID=${data.hospitalID}`,
    method: 'PUT',
    data: {}
  })
}

// 提交资质认证
//   POST doctorJoinApply/qualification/certification
//   接口ID：218324440
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-218324440
// doctorJoinApply/qualification/certification
export const certificationDoctor = data => {
  return request({
    url: `/doctorJoinApply/qualification/certification`,
    method: 'POST',
    data
  })
}

// 科联体加入申请
//   POST /departmental-consortium/departments/union/join/application
//   接口ID：244263327
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-244263327
export const certificationDoctorH5 = data => {
  return request({
    url: `/departmental-consortium/departments/union/join/application`,
    method: 'POST',
    data
  })
}

export const fGetPracticeGroupList = (data = null) => {
  const params = {
    pageNum: 1,
    pageSize: 100,
    state: 1,
    ...data
  }
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetPracticeGroupList',
      hospitalID: (data && data.hospitalID) || '',
      params: JSON.stringify(params)
    }
  })
}

// 识别身份证
// POST /hospro/hospital/fIdentificationCard
// 接口ID：45391144
// 接口地址：https://www.apifox.cn/web/project/956367/apis/api-45391144
export const fIdentificationCard = (file, formName = 'file') => {
  return fileUpload(file, '/hospro/hospital/fIdentificationCard', formName)
}

// 用户的科联体信息查询
//   GET /departmental-consortium/departments/union
//   接口ID：246239840
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-246239840
export const getUserBasicInfo = params => {
  return request({
    url: `/departmental-consortium/departments/union`,
    method: 'GET',
    params
  })
}

/**
 * 会诊相关接口
 */

// 多方会诊查询
export const getMultiPartyConsultations = params => {
  return request({
    url: `/departmental-consortium/MultiPartyConsultations`,
    method: 'GET',
    params
  })
}
// 多方会诊详情
export const getMultiPartyConsultationsDetail = data => {
  return request({
    url: `/departmental-consortium/MultiPartyConsultations/${data}`,
    method: 'GET',
    params: null
  })
}

// 创建会诊订单
export const postMultiPartyConsultations = data => {
  return request({
    url: `/departmental-consortium/MultiPartyConsultations`,
    method: 'POST',
    data
  })
}

// 会诊订单补充资料
export const postInformation = data => {
  const { id } = data
  delete data.id
  return request({
    url: `/departmental-consortium/MultiPartyConsultations/${id}/Files`,
    method: 'POST',
    data
  })
}

// 拒诊会诊订单
export const reject = data => {
  return request({
    url: `/departmental-consortium/MultiPartyConsultations/${data.id}?action=reject`,
    method: 'PUT',
    data
  })
}

// 接诊会诊订单
export const receive = data => {
  return request({
    url: `/departmental-consortium/MultiPartyConsultations/${data}?action=receive`,
    method: 'PUT',
    data
  })
}

// 分诊会诊订单
export const triageMultiPartyConsultations = data => {
  return request({
    url: `/departmental-consortium/MultiPartyConsultations/${data.id}?action=triage`,
    method: 'PUT',
    data
  })
}

// 快速会诊状态修改
export const directUpdateStatus = data => {
  return request({
    url: `/departmental-consortium/MultiPartyConsultations/${data.id}?action=directUpdateStatus`,
    method: 'PUT',
    data
  })
}

//邀请参与多方会诊
export const addMember = data => {
  return request({
    url: `/departmental-consortium/MultiPartyConsultations/${data.id}?action=addMember`,
    method: 'PUT',
    data
  })
}

//取消会诊订单
export const cancel = data => {
  return request({
    url: `/departmental-consortium/MultiPartyConsultations/${data.id}?action=cancel`,
    method: 'PUT',
    data
  })
}

//结束会诊订单
export const complete = data => {
  return request({
    url: `/departmental-consortium/MultiPartyConsultations/${data.id}?action=complete`,
    method: 'PUT',
    data
  })
}

//填写会诊报告
export const fill = data => {
  return request({
    url: `/departmental-consortium/MultiPartyConsultations/${data.id}?action=fillReport`,
    method: 'PUT',
    data
  })
}

// 入网机构查询
export const getOrgManageList = params => {
  return request({
    url: `/CollaborativeOutpatient/orgManageList`,
    method: 'GET',
    params
  })
}

// 查询科室
export const fGetDepartmentList = data => {
  return request({
    url: '/hospro/hospital/selInfo?func=fGetDepartmentList',
    method: 'post',
    data
  })
}

// 科联体医生会员
export const getDoctors = params => {
  return request({
    url: `/departmental-consortium/departments/doctor`,
    method: 'GET',
    params
  })
}

// 获取菜单看是否有权限处理订单
export const loginInfo = params => {
  return request({
    url: `/hospro/user/validFunc`,
    method: 'GET',
    params
  })
}
// 会诊创建视频会议
export const createMeeting = data => {
  return request({
    url: `/departmental-consortium/MultiPartyConsultations/createMeeting`,
    method: 'POST',
    data
  })
}
// 会诊创建视频会议消息通知
export const createMeetingRemind = data => {
  return request({
    url: `/departmental-consortium/MultiPartyConsultations/createMeetingRemind`,
    method: 'POST',
    data
  })
}
// 发短信通知多方会诊医生入会
export const noticeEnterMeeting = data => {
  return request({
    url: `/departmental-consortium/MultiPartyConsultations/${data}?action=noticeEnterMeeting`,
    method: 'POST',
    data
  })
}
//
export const terminal = params => {
  return request({
    url: `/departmental-consortium/departments/terminal`,
    method: 'GET',
    params
  })
}

//  检查项目字典
export const InspectionItem = params => {
  return request({
    url: `/hospro/InspectionItem`,
    method: 'GET',
    params
  })
}

//  查询受者检查报告
export const PatientInspectionReports = params => {
  return request({
    url: `/hospro/PatientInspectionReports`,
    method: 'GET',
    params
  })
}

//  查询受者检查报告详情
export const getReportId = reportId => {
  return request({
    url: `/hospro/PatientInspectionReports/${reportId}`,
    method: 'GET',
    params: {}
  })
}

//  查询受者检查图标数据
export const getEchart = reportId => {
  return request({
    url: `/hospro/PatientInspectionReports`,
    method: 'GET',
    params: {}
  })
}

export const fGetAudioAndVideoAppUsersig = params => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetAudioAndVideoAppUsersig',
      params: JSON.stringify(params)
    }
  })
}
export const fGetIMAppUsersig = params => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetIMAppUsersig',
      params: JSON.stringify(params)
    }
  })
}

export const fGetGroupChatHis = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetGroupChatHis',
      params: JSON.stringify(data)
    }
  })
}

export const getQuickResponses = params => {
  return request({
    url: `/hospro/im/QuickResponses`,
    method: 'GET',
    params
  })
}

export const deleteQuickResponses = params => {
  return request({
    url: `/hospro/im/QuickResponses/${params.id}`,
    method: 'DELETE',
    params
  })
}

export const saveQuickResponses = data => {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: `/hospro/im/QuickResponses`,
    method: 'POST',
    data
  })
}

export const fSearchPrescription = data => {
  return request({
    url: `/hospro/hospital/businessMethods/fSearchPrescription`,
    method: 'POST',
    data
  })
}

export const fGetPrescripTemplate = data => {
  return request({
    url: `/hospro/hospital/businessMethods/fGetPrescripTemplate`,
    method: 'POST',
    data
  })
}

export const fCancelPrescrip = data => {
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    data
  })
}

export const getBusinessConfig = (tableName, code) => {
  const params = {
    pageNum: 1,
    pageSize: 1,
    tableName: tableName,
    code: code
  }
  return request({
    url: `/hospro/hospital/selInfo`,
    method: 'POST',
    params: {
      func: 'fGetBusinessDicList',
      hospitalID: code || '',
      params: JSON.stringify(params)
    }
  })
}

export const getBusinessValueByCode = async (tableName, code) => {
  const keyValues = await getBusinessDicListByName(tableName)

  if (!keyValues) {
    return ''
  }
  const filterValue = keyValues.frequence.filter(item => {
    return item.code === code
  })[0]

  return filterValue ? filterValue.count : ''
}

// 上传图片
export const uploadImage = data => {
  return request({
    url: `/hospro/images/v2`,
    method: 'POST',
    data
  })
}

export const getDicListByName = async (code, dictHospitalID) => {
  // const dictHospitalID = store.state.hospitalInfo
  //   ? store.state.hospitalInfo.hospitalID
  //   : ''
  const rs = await getDicListNew({
    pageSize: 99999,
    tableName: code,
    dictHospitalID
  })
  return rs
}

// 列表
//   GET /hospro/recipientType/list
//   接口ID：332553775
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-332553775
export const getRecipientTypeList = async params => {
  return request({
    url: `/hospro/recipientType/list`,
    method: 'GET',
    params
  })
}

// 查询受者类型
//   GET /hospro/recipientType/listType
//   接口ID：339158378
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-339158378
export const getRecipientTypeOptionList = async params => {
  return request({
    url: `/hospro/recipientType/listType`,
    method: 'GET',
    params
  })
}

// 查询预警记录
//   GET /hospro/AiWarning
//   接口ID：332833661
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-332833661
export const getAiWarningList = async params => {
  return request({
    url: `/hospro/AiWarning`,
    method: 'GET',
    params
  })
}

// 检查结果评估
//   GET /hospro/ai/suggestion
//   接口ID：332808521
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-332808521
export const getAiSuggestion = async params => {
  return request({
    timeout: 5 * 60 * 1000,
    url: `/hospro/ai/suggestion`,
    method: 'GET',
    params
  })
}

// 用药解析
//   GET /hospro/remindTask/ai/suggestion
//   接口ID：338787090
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-338787090
export const getAiDrugSuggestion = async params => {
  return request({
    timeout: 5 * 60 * 1000,
    url: `/hospro/remindTask/ai/suggestion`,
    method: 'GET',
    params
  })
}

// 列表
//   GET /hospro/medicationPlan/list
//   接口ID：332616343
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-332616343
export const getMedicationPlan = async params => {
  return request({
    url: `/hospro/medicationPlan/list`,
    method: 'GET',
    params
  })
}

// 列表
//   GET /hospro/treatment/list
//   接口ID：332587176
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-332587176
export const getTreatmentList = async params => {
  return request({
    url: `/hospro/treatment/list`,
    method: 'GET',
    params
  })
}

// 详情
//   GET /hospro/treatment/detail
//   接口ID：332597467
//   接口地址：https://app.apifox.com/link/project/956367/apis/api-332597467
export const getTreatmentDetail = async params => {
  return request({
    url: `/hospro/treatment/detail`,
    method: 'GET',
    params
  })
}
